interface AudioRecognitionBridgeActivity {
  pathname?: string;
  lessonPlaying: boolean;
  repertoirePlaying: boolean;
  documentVisible: boolean;
}

const matchesRoute = (pathname: string, route: string) =>
  pathname === route || pathname.startsWith(`${route}/`);

export const shouldPrimeAudioRecognitionBridge = ({
  pathname = '',
  documentVisible,
}: Pick<AudioRecognitionBridgeActivity, 'pathname' | 'documentVisible'>) => {
  if (!documentVisible) return false;

  const normalizedPath = pathname.replace(/\/$/, '');
  return (
    matchesRoute(normalizedPath, '/tutorial') ||
    matchesRoute(normalizedPath, '/lesson') ||
    matchesRoute(normalizedPath, '/repertoire-play')
  );
};

export const shouldRunAudioRecognitionBridge = ({
  pathname = '',
  lessonPlaying,
  repertoirePlaying,
  documentVisible,
}: AudioRecognitionBridgeActivity) => {
  if (!shouldPrimeAudioRecognitionBridge({ pathname, documentVisible })) return false;

  const normalizedPath = pathname.replace(/\/$/, '');
  if (matchesRoute(normalizedPath, '/tutorial')) return true;
  if (matchesRoute(normalizedPath, '/lesson')) return lessonPlaying;
  if (matchesRoute(normalizedPath, '/repertoire-play')) return repertoirePlaying;

  return false;
};
